import { Breakpoint, TableMenuHeading } from "@enxcs/dap-ui-stratos";

export const createAgendaTableHeadings = (t: (key: string) => string): TableMenuHeading[] => {
  return [
    { content: t("prepareModal.agendaStep.table.headers.agenda"), breakpoint: Breakpoint.M },
    { content: t("prepareModal.agendaStep.table.headers.date"), breakpoint: Breakpoint.M },
    { content: t("prepareModal.agendaStep.table.headers.time"), breakpoint: Breakpoint.M },
  ];
};
